export default {
    BRICK:'brick',
    FIRE_RESISTIVE:'fire-resistive',
    MASONRY:'masonry',
    FRAME:'frame',

    // these are commented out for now,
    // we may moves items in our out of this list
    //so keeping them here for ease of development

    // AGGREGATE:"aggregate",
    // ALUMINIUM:"aluminium",
    // ASBESTOS:"asbestos",
    // CEMENT:"cement",
    // FIBERGLASS:"fiberglass",
    // LOG:"log",
    // MASONITE:"masonite",
    // MASONRY_NON_COMBUSTIBLE:"masonry-non-combustible",
    // MASONRY_VENEER:"masonry-veneer",
    // MONO:"mono",
    // NON_FIRE_RESISTIVE_APARTMENT:"non-fire-resistive-apartment",
    // STEEL:"steel",
    // STONE:"stone",
    // STONE_VENEER:"stone-veneer",
    // STUCCO:"stucco",
    // VINYL:"vinyl",
    // WOOD_EXTERIOR:"wood-exterior",
    // CONCRETE_MASONRY_BLOCKS:"concrete-blocks",

    OTHER:'other',
};
